module.exports = __webpack_public_path__ + "static/magenta-d01bd1dc3e65eca431f06d2b9de31456.svg";